import { string, object, oneOf, instanceOf } from 'prop-types'
import updateDayView from './dayView'
import updateEditMode from './editMode'
import updateMonthView from './monthView'
import updateSharedStyles from './shared'
import updateSingleMoment from './singleMoment'
import updateTextView from './text'
import updateWeekView from './weekView'

const getStyles = (theme) => {
  const {
    background_color: backgroundColor,
    secondary_background_color: secondaryBackgroundColor,
    background_image: backgroundImage,
    background_image_opacity: backgroundImageOpacity,
    title_font_family: titleFontFamily,
    title_font_weight: titleFontWeight,
    title_font_color: titleFontColor,
    title_font_size: titleFontSize,
    body_font_family: bodyFontFamily,
    body_font_weight: bodyFontWeight,
    body_font_color: bodyFontColor,
    body_font_size: bodyFontSize,
    content_card_color: contentCardColor,
    logo_alignment: logoAlignment,
  } = theme

  const cardBoxShadow = '0 2px 4px 0 rgba(0, 0, 0, 0.15)'

  return {
    backgroundColor,
    secondaryBackgroundColor,
    backgroundImage,
    backgroundImageOpacity,
    titleFontFamily,
    titleFontWeight,
    titleFontColor,
    titleFontSize,
    bodyFontFamily,
    bodyFontWeight,
    bodyFontColor,
    bodyFontSize,
    contentCardColor,
    logoAlignment,
    cardBoxShadow,
  }
}

const updateRelevantSlide = (props, styles) => {
  switch (props.slideType) {
    case 'text':
      updateTextView(styles)
      break
    case 'single_moment':
      updateSingleMoment(styles)
      break
    case 'week_view':
      updateWeekView(styles)
      break
    case 'month_view':
      updateMonthView(styles)
      break
    case 'run_of_show':
      updateDayView(styles)
      break
    default:
      break
  }
}

const PresentationTheme = (props) => {
  const styles = getStyles(props.theme || {})

  updateRelevantSlide(props, styles)
  updateSharedStyles(styles, props.element)

  if (props.viewContext === 'editing') {
    updateEditMode()
  }

  return null
}

PresentationTheme.propTypes = {
  element: instanceOf(Element),
  slideType: oneOf([
    'text',
    'single_moment',
    'week_view',
    'month_view',
    'run_of_show',
  ]),
  theme: object,
  viewContext: string,
}

export default PresentationTheme
